import ProductUpdateExcelService from '../../services/ProductUpdateExcelService';
import productUpdateExcelUseCase from './productUpdateExcelUseCase';

const leadFactory = productUpdateExcelUseCase({
  ProductUpdateExcelService: ProductUpdateExcelService(),
});

export default leadFactory;
